import {Component, computed, inject, signal} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {MatOption, MatSelect, MatSelectTrigger} from '@angular/material/select';
import {NgTemplateOutlet} from '@angular/common';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {take} from 'rxjs/operators';
import {IackathonProgressViewerComponent} from '../../components/iackathon-progress-viewer/iackathon-progress-viewer.component';
import {IackathonStepDetailsComponent} from '../../components/iackathon-step-details/iackathon-step-details.component';
import {IACKATHON_STEP, IACKATHON_STEP_LABEL_KEY} from '../../models/iackathon_steps';
import {IackathonSave, IackathonSavesService} from '../../services/iackathon-saves.service';

@Component({
  selector: 'app-iackathon-group-details-page',
    imports: [
        RouterLink,
        MatFormFieldModule,
        MatIconModule,
        MatSelect,
        MatSelectTrigger,
        MatOption,
        NgTemplateOutlet,
        IackathonProgressViewerComponent,
        MatProgressSpinner,
        IackathonStepDetailsComponent,
        TranslateModule
    ],
  templateUrl: './iackathon-group-details-page.component.html',
})
export class IackathonGroupDetailsPageComponent {
    private router = inject(Router);
    private activatedRoute = inject(ActivatedRoute);
    private iackathonSavesService = inject(IackathonSavesService);

    protected readonly isLoading = signal(false);
    private readonly urlParams = toSignal(this.activatedRoute.paramMap);
    protected readonly groupSaveId = computed(() => this.urlParams().get('id') ?? '');
    protected readonly groupSaves = this.iackathonSavesService.cachedSaves;
    protected readonly selectedSave= computed(() => this.groupSaves().find(save => save.id === this.groupSaveId()) ?? null);
    protected readonly activeStep = signal<IACKATHON_STEP>("keyNumber");
    protected readonly stepLabelKeys = IACKATHON_STEP_LABEL_KEY;

    constructor() {
        if (this.iackathonSavesService.cachedSaves().length === 0) {
            this.isLoading.set(true);
            this.iackathonSavesService.fetchSaves().pipe(
                take(1)
            ).subscribe(() => this.isLoading.set(false));
        }
    }

    protected getSaveMembers(save: IackathonSave) {
        const members = save.attributes.content.state.members;
        return Array.isArray(members) ? members : [];
    }

    protected onSelectSaveChange(selectedSaveId: string): void {
        this.router.navigate(['/iackathon-groups', selectedSaveId]);
    }
}
